export enum FlashMessageCreatedFor {
  RESCHEDULED_BY_AGENT = 'rescheduled_by_agent',
}
